import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { getConsent } from "@/lib/cookieConsent";
import Navbar from "@/components/Navbar";
import HeroCarousel from "@/components/HeroCarousel";
import EmergencyBar from "@/components/EmergencyBar";
import LatestArticle from "@/components/LatestArticle";
import ServicesSection from "@/components/ServicesSection";
import AboutStats from "@/components/AboutStats";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function PublicSite() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
    const maybeTrack = () => {
      try {
        const c = getConsent();
        if (c?.analytics && !sessionStorage.getItem("simserv_tracked")) {
          sessionStorage.setItem("simserv_tracked", "1");
          api.post("/track", { path: window.location.pathname }).catch(() => {});
        }
      } catch (e) {}
    };
    maybeTrack();
    window.addEventListener("cookie-consent-updated", maybeTrack);
    return () => window.removeEventListener("cookie-consent-updated", maybeTrack);
  }, []);

  if (!content)
    return (
      <div className="min-h-screen flex items-center justify-center text-[#0F1E36]">
        Se încarcă...
      </div>
    );

  const { settings, services } = content;
  const company = settings.company;

  return (
    <div className="bg-white">
      <Navbar company={company} />
      <main>
        <HeroCarousel slides={settings.hero_slides || []} company={company} />
        <EmergencyBar company={company} roadside={settings.roadside} />
        <LatestArticle />
        <ServicesSection services={services} />
        <AboutStats about={settings.about || {}} />
        <ContactSection company={company} services={services} />
      </main>
      <Footer company={company} />
    </div>
  );
}
